import gql from 'graphql-tag';

export const GET_CARD_NETWORK_IDS = gql`
  fragment CardData on CardData {
    updatedAt
    cnids {
      externalId
      transactedAt
      type
      transacting
    }
  }

  query getCardNetworkIds($venueUuid: String!) {
    cardNetworkIds(venueUuid: $venueUuid) {
      amex {
        ...CardData
      }

      visa {
        ...CardData
      }

      mastercard {
        ...CardData
      }
    }
  }
`;

export default GET_CARD_NETWORK_IDS;
